import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Menu, Select } from "antd"

import { updateBifurcation } from "../../../data/redux/admin_details/actions"
import ErrorBoundary from "../../../components/errorboundary"

const Bifurcation = ({
  bifurcation,
  admin_id,
  mobile_view,
  actions
}) => {

  const handleSelectChange = (option, valueKey) => {
    if (valueKey) {
      const payload = {
        adminPsid: admin_id,
        selectedBifurcation: {
          ...bifurcation.selected,
          [valueKey]: {
            value: option.props.value,
            meta: option.props.meta
          }
        }
      }
      actions.updateBifurcation(payload, bifurcation)
    }
  }

  const renderSelect = filter => {
    return (
      <Select
        size="small"
        style={{ width: "100px" }}
        {...filter.props}
        value={bifurcation.selected[filter.valueKey] ? bifurcation.selected[filter.valueKey].value : null}
        onChange={(val, opt) => handleSelectChange(opt, filter.valueKey)}
      >
        {
          filter.options.map((option, index) => (
            <Select.Option
              key={index}
              value={option.value}
              meta={option.meta}
            >
              {option.label}
            </Select.Option>
          ))
        }
      </Select>
    )
  }

  if (bifurcation && bifurcation.filters.length > 0)
    return bifurcation.filters.map((filter, index) => {
      switch (filter.type) {
        case "select":
          return (
            <ErrorBoundary key={index}>
              {
                mobile_view ?
                  <Menu.Item key={index} className="ori-no-mrgn ori-lr-pad-15">
                    {renderSelect(filter)}
                  </Menu.Item>
                  :
                  <li className="ori-flex-column ori-flex-jc navItem">
                    {renderSelect(filter)}
                  </li>
              }
            </ErrorBoundary>
          )
        default: return null
      }
    })
  return null
}

const mapStateToProps = state => ({
  bifurcation: state.admin_details.bifurcation_data,
  admin_id: state.admin_details.admin_id
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ updateBifurcation }, dispatch),
  }
}

Bifurcation.propTypes = {
  bifurcation: PropTypes.object,
  mobile_view: PropTypes.bool,
  actions: PropTypes.object,
  admin_id: PropTypes.string
}

Bifurcation.defaultProps = {
  bifurcation: {},
  mobile_view: false
}

export default connect(mapStateToProps, mapDispatchToProps)(Bifurcation)



// WEBPACK FOOTER //
// ./src/components/appheader/bifurcation/index.js